import Accordion from 'react-bootstrap/Accordion';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Reveal from '../atoms/Reveal';
import { perguntas } from '../content/site';

/** As perguntas que aparecem antes da decisão. Nenhuma delas é sobre o sistema:
 *  são todas sobre a operação de quem vende comida — taxa, maquininha, meio a
 *  meio, balcão. É o que a pessoa precisa resolver para dizer sim. */
function Faq() {
  return (
    <section className="section section--alt faq" id="perguntas">
      <Container className="shell">
        <div className="section-head section-head--center">
          <span className="section-kicker">Perguntas</span>
          <h2 className="section-title">O que costumam perguntar antes de começar</h2>
        </div>

        <Row className="justify-content-center">
          <Col lg={9}>
            {/* Sem `alwaysOpen` e sem item aberto por padrão: a lista fecha uma
                ao abrir outra, e quem chega vê as sete perguntas de uma vez em
                vez de uma resposta comprida no lugar delas. */}
            <Accordion flush>
              {perguntas.map((item, i) => (
                <Reveal as={Accordion.Item} key={item.p} eventKey={String(i)} stagger={i}>
                  <Accordion.Header>{item.p}</Accordion.Header>
                  <Accordion.Body>{item.r}</Accordion.Body>
                </Reveal>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Faq;
